import React, { useState } from 'react'
import {
  Grid,
  Tooltip,
  Icon,
  Box,
  Dialog,
  TextField,
  Button,
} from '@mui/material'
import { toast } from 'react-toastify'

export default function TagDialog({ handleAddTag, isMaximumReached }) {
  const [open, setOpen] = React.useState(false)
  const [key, setKey] = useState('')
  const [value, setValue] = useState('')

  function handleClickOpen() {
    if (isMaximumReached) return
    setOpen(true)
  }

  function handleClose() {
    setOpen(false)
  }
  const disabled = !key || !value
  const handleAddClick = () => {
    if (isMaximumReached) {
      return toast.error('Maximum limit reached')
    }
    if (disabled) return
    handleAddTag({ key, value })
    setKey('')
    setValue('')
    handleClose()
  }
  return (
    <div>
      <Button
        variant="text"
        color="primary"
        disabled={isMaximumReached}
        className={'font-bold mb-1'}
        startIcon={<Icon> add </Icon>}
        onClick={handleClickOpen}
      >
        Add custom property (Up to 50 properties)
      </Button>

      <Dialog
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <h4 id="form-dialog-title" className="capitalize m-0 mb-4">
          Add custom property
        </h4>
        <Grid container spacing={2}>
          <Grid item sm={4} xs={12}>
            <Tooltip
              title={key && key.length > 25 ? key : ''}
              placement="top"
              arrow
            >
              <TextField
                autoFocus
                id="key"
                value={key}
                label="Key"
                variant="outlined"
                size="small"
                fullWidth
                inputProps={{
                  maxLength: 128,
                }}
                onChange={(event) => {
                  setKey(event.target.value)
                }}
              />
            </Tooltip>
          </Grid>
          <Grid item sm={8} xs={12}>
            <Tooltip
              title={value && value.length > 50 ? value : ''}
              placement="top"
              arrow
            >
              <TextField
                id="value"
                value={value}
                label="Value"
                variant="outlined"
                size="small"
                fullWidth
                inputProps={{
                  maxLength: 256,
                }}
                onChange={(event) => {
                  setValue(event.target.value)
                }}
              />
            </Tooltip>
          </Grid>
        </Grid>
        <Box className="flex justify-end pt-2 mt-2">
          <Button variant="outlined" color="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className="ml-2"
            disabled={disabled}
            onClick={handleAddClick}
            variant="outlined"
            color="primary"
          >
            Add
          </Button>
        </Box>
      </Dialog>
    </div>
  )
}
